import React from 'react';
import { motion } from 'framer-motion';

const CHAPTERS = [
  {
    n: '01',
    title: 'Find your places',
    body: 'The independents near you, with their real menus and their real prices. Nothing marked up, nothing rearranged to sell you something else.',
  },
  {
    n: '02',
    title: 'Order in a tap',
    body: 'Pick what you want and check out as a guest. Your details save on your own phone, so the second order takes about ten seconds.',
  },
  {
    n: '03',
    title: 'Collect it, or have it brought',
    body: "Pick up at the counter, or have it delivered if that restaurant offers it — each one sets its own area and its own charge.",
  },
];

const Manifesto = () => (
  <section className="relative py-16 sm:py-24 px-6 sm:px-10" data-testid="manifesto-section">
    <div className="max-w-6xl mx-auto">
      <motion.p
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-80px' }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="font-mono2 text-[11px] uppercase tracking-[0.45em] text-[#f15a24] text-center"
      >
        What we do
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-80px' }}
        transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
        className="mt-4 font-display font-medium text-4xl sm:text-5xl text-center text-[#171512]"
      >
        Two sides of the same door
      </motion.h2>

      <div className="mt-12 sm:mt-16 grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-6">
        {CHAPTERS.map((c, i) => (
          <motion.article
            key={c.n}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
            whileHover={{ y: -5 }}
            data-testid={`manifesto-chapter-${c.n}`}
            className="group bg-white border border-black/10 shadow-sm rounded-3xl p-8 transition-colors duration-300 hover:border-[#f15a24]/40"
          >
            <p className="font-mono2 text-xs tracking-[0.3em] text-[#f15a24]">{c.n}</p>
            <h3 className="mt-3 font-display font-medium text-2xl text-[#171512]">{c.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-[#6e6a63]">{c.body}</p>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);

export default Manifesto;
